export const DATA_FIRESTORE_V01_USER_PROFILES = {
  NAME: 'v01_user_profiles',
}
